export default __webpack_public_path__ + "static/media/Copper_Nov20_Rank.8191d951.png";